interface Config {
    apiUrl: string;
  }
  
  interface Configs {
    development: Config;
    production: Config;
  }
  
  const config: Configs = {
    development: {
          apiUrl: "https://api-financetool.rsk-bsl.co.uk/api" 
    },
    production: {
        apiUrl: "https://api-financetool.rsk-bsl.co.uk/api"
    }
  };
  
  export default config;